/* eslint-disable no-case-declarations */
import {
  toggleAddRemoveItemsFromSelectedList,
  resetDeletionState,
  updateDeletionState,
  updateStateAfterSuccessfulDeletion,
  toggleCheckAllItems,
  updateSelectedItemsCount,
} from './reducer_helpers';
import DELETE_ACTIONS from './actions';
import { getAllowedItemsList } from '../@helper_functions/helpers';

// !========================
// ! The Reducer function:
// !========================
const deletionReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    //* Activate deletion mode:
    case DELETE_ACTIONS.ACTIVATE_DELETION_MODE: {
      return {
        ...state,
        isDeletionModeActive: true,
        ...toggleAddRemoveItemsFromSelectedList(state, payload),
        ...updateSelectedItemsCount(state),
      };
    }

    //* Activate deletion confirmation Message:
    case DELETE_ACTIONS.ACTIVATE_DELETE_CONFIRMATION:
      return {
        ...state,
        isDeleteConfirmationActive: true,
      };
    //* Deactivate deletion confirmation Message:
    case DELETE_ACTIONS.DEACTIVATE_DELETE_CONFIRMATION:
      return {
        ...state,
        isDeleteConfirmationActive: false,
      };

    //* Deactivates deletion mode.
    case DELETE_ACTIONS.DEACTIVATE_DELETION_MODE:
      return {
        ...state,
        isDeletionModeActive: false,
        isDeleteConfirmationActive: false,
        selectedItems: [],
      };

    // return {}

    //* Reset deletion state:
    case DELETE_ACTIONS.RESET_DELETION_STATE:
      return {
        ...state,
        ...resetDeletionState(state),
      };

    //* Update deletion state:
    case DELETE_ACTIONS.UPDATE_DELETION_STATE:
      return {
        ...state,
        ...updateDeletionState(state, payload),
      };

    //* Add item's id to the selected items array:
    case DELETE_ACTIONS.TOGGLE_ADD_ITEM_TO_SELECTED_ITEMS:
      return {
        ...state,
        ...toggleAddRemoveItemsFromSelectedList(state, payload),
      };

    //* Add item's id to the selected items array:
    case DELETE_ACTIONS.SUCCESSFUL_DELETION:
      const stateAfterSuccessfulDeletion =
        updateStateAfterSuccessfulDeletion(state);

      return {
        ...state,
        ...stateAfterSuccessfulDeletion,
      };

    //* Updates the data array and creates the allowed items list:
    case DELETE_ACTIONS.GENERATE_ALLOWED_ITEMS_LIST: {
      const allowedItemsList = getAllowedItemsList(state);

      return {
        ...state,
        itemsAllowedToDelete: allowedItemsList,
      };
    }

    //* 
    case DELETE_ACTIONS.TOGGLE_CHECK_ALL_ALLOWED_ITEMS: {
      const newChangesToState = toggleCheckAllItems(state);

      return {
        ...state,
        ...newChangesToState,
      };
    }

    default:
      return state;
  }
};

export default deletionReducer;



// WEBPACK FOOTER //
// ./src/MultiDeletionFunctionality/@state_manager/reducer.js